export const PRICE_AFTER_DEDUCTIONS_KEY = "price_after_deductions";
export const PREVENT_AS_INPUT = ["e", "E", "+", "-", "."];
